import { v4 as uuidv4 } from 'uuid';

(function () {
    fabric.util.object.extend(fabric.Canvas.prototype, {
        _isCloning: false,
        _clonedElement: null,
        startedToMoveObject: false,

        _initCloneEvents: function () {
            this.on('mouse:down', (opt) => {
                const evt = opt.e;
                const object = this.getActiveObject();

                if (!evt.altKey || !object || this._isCloning || object.type == 'activeSelection') return;
                this._isCloning = true;
                if (window.DD_RUM) {
                    window.DD_RUM.addAction('Duplicate with Drag');
                }

                this._cloneSelection(undefined, {
                    omitSelection: true,
                    saveHistory: true
                }).then(([element]) => {
                    this._clonedElement = element;
                    this._clonedElement?.set({
                        selectable: false,
                        svgString: object.svgString
                    });

                    this.setActiveObject(object);
                    object.set({
                        uuid: uuidv4(),
                        zIndex: this.getHighestZIndex?.() + 1
                    });
                    this.requestRenderAll();
                });
            });

            this.on('object:moving', () => {
                this.startedToMoveObject = true;
            });

            this.on('object:modified', this.finishedMovingElement.bind(this));
        },

        finishedMovingElement: function () {
            if (this.startedToMoveObject && this._isCloning) {
                this._clonedElement?.set({
                    selectable: true
                });
                this.fire('object:cloned', { original: this._clonedElement, clone: this.selection });
            }
            this._isCloning = false;
            this._clonedElement = null;
            this.startedToMoveObject = false;
        }
    });
})();
